if (!customElements.get('pw-email-signup')) {
  customElements.define('pw-email-signup',
    class extends HTMLElement {
      static API_URL = 'https://a.klaviyo.com/client/subscriptions';
      static API_REVISION = '2026-07-15';

      connectedCallback() {
        this.publicKey = (this.dataset.klaviyoKey || '').trim();
        this.listId = (this.dataset.klaviyoList || '').trim();
        this.form = this.querySelector('form');

        // Without Klaviyo settings the form posts to Shopify as a normal customer form
        if (!this.publicKey || !this.listId || !this.form) return;

        this.input = this.form.querySelector('input[type="email"]');
        this.button = this.form.querySelector('button[type="submit"]');
        this.row = this.form.querySelector('.pw-es__form-row');
        this.success = this.querySelector('[data-pw-es-success]');
        this.error = this.querySelector('[data-pw-es-error]');

        this.submitHandler = (event) => this.handleSubmit(event);
        this.form.addEventListener('submit', this.submitHandler);
      }

      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.submitHandler);
      }

      async handleSubmit(event) {
        event.preventDefault();
        if (this.button.disabled) return;

        const email = this.input.value.trim();
        this.setError('');
        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');

        let response;
        try {
          response = await fetch(`${this.constructor.API_URL}?company_id=${encodeURIComponent(this.publicKey)}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/vnd.api+json',
              revision: this.constructor.API_REVISION
            },
            body: JSON.stringify(this.buildPayload(email))
          });
        } catch (e) {
          // Klaviyo unreachable (e.g. ad blocker) - fall back to Shopify's customer form so the signup isn't lost
          this.form.removeEventListener('submit', this.submitHandler);
          HTMLFormElement.prototype.submit.call(this.form);
          return;
        }

        this.button.disabled = false;
        this.button.removeAttribute('aria-busy');

        if (response.ok) {
          this.showSuccess(email);
        } else {
          this.setError(this.dataset.errorMessage);
        }
      }

      buildPayload(email) {
        return {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: this.dataset.klaviyoSource || 'PW Email Signup',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email,
                    subscriptions: {
                      email: { marketing: { consent: 'SUBSCRIBED' } }
                    }
                  }
                }
              }
            },
            relationships: {
              list: { data: { type: 'list', id: this.listId } }
            }
          }
        };
      }

      showSuccess(email) {
        this.row.hidden = true;
        this.success.hidden = false;

        // Tie this browser's onsite activity to the new profile
        if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
          window.klaviyo.identify({ email });
        }
      }

      setError(message) {
        this.error.textContent = message || '';
        this.error.hidden = !message;
      }
    }
  );
}
